import React from 'react';

import classNames from 'classnames';
import { Link } from '@ergeon/core-components';
import { IconSocialFacebook, IconSocialInstagram, IconSocialMedium } from '@ergeon/icons/react';

import { SocialLinksProps } from './types';

const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/eraborhood',
    Icon: IconSocialFacebook,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/ergeon/',
    Icon: IconSocialInstagram,
  },
  {
    name: 'Medium',
    href: 'https://medium.com/@ergeon',
    Icon: IconSocialMedium,
  },
];

const LINK_CLASSES = classNames(
  'rounded-md text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white',
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-blue-500 dark:focus-visible:ring-blue-300',
);

const SocialLinks: React.FC<SocialLinksProps> = ({ className }) => (
  <div className={classNames('flex items-center gap-4', className)}>
    {SOCIAL_LINKS.map(({ href, Icon, name }) => (
      <Link
        aria-label={name}
        className={LINK_CLASSES}
        href={href}
        key={name}
        rel="noopener noreferrer"
        target="_blank"
        unstyled>
        <Icon aria-hidden="true" className="size-6 shrink-0" />
      </Link>
    ))}
  </div>
);

export default SocialLinks;
